<div class="generate-link-form">
  <form [formGroup]="form" (ngSubmit)="generateLink()">
      <div class="row">
        <h4 class="vox-heading-4" translate>marketing.offer-link.generate-link-form.title</h4>
        <div class="col-sm-12">
          <label for="country" translate>marketing.offer-link.generate-link-form.country.label</label>
          <vox-select-country [language]="language" [countryList]="countries" [dense]="true" [searchEnabled]="false"
            formControlName="country">
          </vox-select-country>
          </div>
          <div class="col-sm-12">
              <label for="coupon" translate>marketing.offer-link.generate-link-form.coupon.label</label>
              <div class="vox-input-group vox-input-group_dense"
                [ngClass]="{'vox-input-group_invalid': isFieldInvalid('coupon') }">
                  <input class="vox-text-field" type="text" id="coupon" formControlName="coupon"
                    [placeholder]="'marketing.offer-link.generate-link-form.coupon.placeholder' | translate"/>
                  <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
                  <span class="vox-input-group__error-message" translate>marketing.offer-link.generate-link-form.required</span>
              </div>
          </div>
          <div class="col-sm-12">
            <label for="language" translate>marketing.offer-link.generate-link-form.language.label</label>
            <div ngbDropdown class="vox-dropdown-input">
                <button
                  role="button"
                  type="button"
                  ngbDropdownToggle>
                  {{'marketing.offer-link.generate-link-form.language.' + form.value.language.locale.toLowerCase() | translate}}
                </button>
                <div ngbDropdownMenu>
                  <a
                    type="button"
                    (click)="onSelectLanguage(language)"
                    *ngFor="let language of languages"
                    ngbDropdownItem>
                    {{'marketing.offer-link.generate-link-form.language.' + language.locale.toLowerCase() | translate}}
                  </a>
                </div>
            </div>
          </div>
          <div class="col-sm-12">
            <label for="wifi" translate>marketing.offer-link.generate-link-form.wifi.label</label>
            <div ngbDropdown class="vox-dropdown-input">
                <button
                  role="button"
                  type="button"
                  [disabled]="isWifiDisabled"
                  ngbDropdownToggle>
                  {{'marketing.offer-link.generate-link-form.wifi.' + form.value.wifi | translate}}
                </button>
                <div ngbDropdownMenu>
                  <a
                    type="button"
                    (click)="onSelectWifi(wifi)"
                    *ngFor="let wifi of wifiList"
                    ngbDropdownItem>
                    {{'marketing.offer-link.generate-link-form.wifi.' + wifi | translate}}
                  </a>
                </div>
            </div>
          </div>
      </div>
      <div class="submit-container">
          <button class="vox-btn vox-btn-primary" [disabled]="form.invalid" type="submit" translate>
            marketing.offer-link.generate-link-form.submit
          </button>
      </div> 
  </form>
</div>
